// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftSaveStatus_decode($$enum) {
  if ($$enum === "NotSaved" || $$enum === "SaveFailed" || $$enum === "FirstSaveInProgress" || $$enum === "Saved" || $$enum === "SaveInProgress") {
    return $$enum;
  }
}

let localDraftSaveStatus_fromString = localDraftSaveStatus_decode;

let Utils = {
  localDraftSaveStatus_decode: localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: localDraftSaveStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelaySaveDraft_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftSaveStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
